export const monitorSwitchingViews = {
  DOORS: 'doors',
  EMPLOYEES: 'employees',
};

export const monitorSwitchingViewsDuration = {
  [monitorSwitchingViews.DOORS]: 325 * 1000, // 325 sec = 130 doors / (2 doors / 5 seconds)
  [monitorSwitchingViews.EMPLOYEES]: 60 * 1000, // 1 min
};

export const monitorStat = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  SLOW: 'SLOW',
  NORMAL: 'NORMAL',
  FAST: 'FAST',
  STOPPED: 'STOPPED',
  FINISHED: 'FINISHED',
  EMPTY: 'EMPTY'
}

export const monitorStatsDefaultProps = {
  [monitorStat.NOT_STARTED]: { title: 'Not Started', color: '#232526' },
  [monitorStat.SLOW]: { title: 'Slow', color: '#FAAD14' },
  [monitorStat.NORMAL]: { title: 'Normal', color: '#52C41A' },
  [monitorStat.FAST]: { title: 'Fast', color: '#42B0D5' },
  [monitorStat.STOPPED]: { title: 'Stopped', color: '#F5222D' },
  [monitorStat.FINISHED]: { title: 'Finished', color: '#1560AD' },
  [monitorStat.EMPTY]: { title: 'Empty', color: '#828C94' },
  [monitorStat.IN_PROGRESS]: { title: 'In Progress', color: '#52C41A' },
};